import { Component, Input, EventEmitter } from '@angular/core';
import { BaseComponent } from '@varsity/components';
import {
    LoggingService, TokenService, LocalStorageService,
    NotificationsService, AccountService,
    UserCreate, PlatformService
} from "@varsity/services";
import { ViewController, ToastController, NavParams, PopoverController } from 'ionic-angular';
import { InAppBrowser } from '@ionic-native/in-app-browser';

/**
 * Generated class for the SportFilterComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'sport-filter',
    templateUrl: 'sport-filter.html'
})
export class SportFilterComponent extends BaseComponent {
    filterOptions: { Icon: string, Name: string, IsSelected: boolean }[];
    filterSelected: (filter: { Icon: string, Name: string, IsSelected: boolean }) => void;

    constructor(
        protected loggingService: LoggingService,
        protected tokenService: TokenService,
        protected localStorageService: LocalStorageService,
        protected notificationsService: NotificationsService,
        protected accountService: AccountService,
        protected toastCtrl: ToastController,
        protected viewCtrl: ViewController,
        protected popoverCtrl: PopoverController,
        protected platformService: PlatformService,
        protected navParams: NavParams,
        protected iab: InAppBrowser,
    ) {
        super(
            loggingService, tokenService, localStorageService,
            notificationsService, platformService, toastCtrl, popoverCtrl, iab,
            "SportFilterComponent"
        );
        this.filterOptions = this.navParams.get("filters");
        this.filterSelected = this.navParams.get('filterSelect');
    }

    ngOnInit() {
        super.ngOnInit();

        // nice example for debounce
        // https://stackoverflow.com/questions/32051273/angular-and-debounce
    }

    Close(): void {
        this.viewCtrl.dismiss();
    }

    triggerFilterSelect(filter: { Icon: string, Name: string, IsSelected: boolean }) {
        filter.IsSelected = !filter.IsSelected;
        this.filterSelected(filter);
    }
    

}



// WEBPACK FOOTER //
// ./src/components/sport-filter/sport-filter.ts